import { captureException } from '@sentry/vue';

/**
 * Captures information about the Axois error using the provided function
 *
 * @param {function(Error): Object} extractErrorInformation
 * @returns {(error: Error) => void}
 */
export const createAxiosErrorHandler = (
  extractErrorInformation = () => {}
) => (
  error
) => {
  captureException(error, { extra: extractErrorInformation(error) });

  throw error;
};
